import { laceParts0, laceParts1, laceParts2, laceParts4, laceParts5 } from './parts/laceParts'
import { topSidePartOfWeb } from './parts/sideParts'

export const netVWeb = (ctx: CanvasRenderingContext2D, webColor: string, laceColor: string, stitchColor: string): void => {
  ctx.lineWidth = 1.0
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ_縦
  verticalPartOfVWeb2(ctx, webColor, stitchColor)
  // laceここから
  laceParts0(ctx, laceColor, -5, -17) // ウェブ縦左上
  laceParts0(ctx, laceColor, 2, 5) // ウェブ縦左上
  laceParts2(ctx, laceColor, 10, 23)
  laceParts2(ctx, laceColor, 18, 40)
  laceParts2(ctx, laceColor, 29, 60)
  laceParts2(ctx, laceColor, 37, 80)
  laceParts2(ctx, laceColor, 45, 100)
  laceParts1(ctx, laceColor, 45, 75) // 上4
  laceParts1(ctx, laceColor, 32, 50) // 上3
  laceParts1(ctx, laceColor, 20, 30) // 上2
  laceParts1(ctx, laceColor, -2, -5) // 上1
  laceParts4(ctx, laceColor, 29, 80) // 上5
  laceParts4(ctx, laceColor, 21, 57) // 上4
  laceParts4(ctx, laceColor, 11, 28) // 上3
  laceParts4(ctx, laceColor, 0, 0) // 上2
  laceParts4(ctx, laceColor, -8, -27) // 上1
  laceParts5(ctx, laceColor, -8, -30) // 上1
  laceParts5(ctx, laceColor, 0, 0) // 上2
  laceParts5(ctx, laceColor, 11, 27) // 上3
  laceParts5(ctx, laceColor, 21, 55) // 上4
  laceParts5(ctx, laceColor, 29, 83) // 上5
  laceParts4(ctx, laceColor, -10, -52) // 上0

  // ウェブ先端
  topSidePartOfWeb(ctx, webColor, laceColor, stitchColor)

  crossLace(ctx, laceColor, -42, -105)
  crossLace(ctx, laceColor, -27, -77)
  crossLace(ctx, laceColor, -14, -40)
  crossLace(ctx, laceColor, 5, -2)
}

const verticalPartOfVWeb2 = (ctx: CanvasRenderingContext2D, webColor: string, stitchColor: string) => {
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = webColor
  // ウェブ_縦
  ctx.beginPath()
  ctx.moveTo(244, 225) // 左＿上
  ctx.quadraticCurveTo(291, 289, 317, 352) // 左＿下
  ctx.quadraticCurveTo(333, 324, 333, 324) // 右＿下
  ctx.quadraticCurveTo(311, 254, 270, 184) // 右＿上
  ctx.quadraticCurveTo(235, 234, 244, 225) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
  ctx.beginPath()
  ctx.moveTo(296, 153) // 左＿上
  ctx.quadraticCurveTo(311, 254, 333, 325) // 左＿下
  ctx.quadraticCurveTo(353, 288, 353, 288) // 右＿下
  ctx.quadraticCurveTo(339, 233, 330, 122) // 右＿上
  ctx.quadraticCurveTo(319, 124, 296, 153) // 左＿上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  ctx.lineWidth = 1.2
  ctx.strokeStyle = stitchColor
  ctx.beginPath()
  ctx.setLineDash([3, 3])
  // 左＿左
  ctx.moveTo(248, 223) // 上
  ctx.quadraticCurveTo(288, 271, 317, 344) // 下
  // 左＿右
  ctx.moveTo(269, 190) // 上
  ctx.quadraticCurveTo(308, 261, 328, 322) // 下
  // 右＿左
  ctx.moveTo(300, 153) // 上
  ctx.quadraticCurveTo(316, 258, 332, 313) // 下
  // 右＿右
  ctx.moveTo(327, 128) // 上
  ctx.quadraticCurveTo(334, 236, 347, 292) // 下
  ctx.stroke()
  ctx.setLineDash([])
  ctx.closePath()
  ctx.strokeStyle = '#282828'
}

const crossLace = (ctx: CanvasRenderingContext2D, laceColor: string, x: number, y: number): void => {
  // 左上＿右下
  ctx.strokeStyle = laceColor
  ctx.strokeStyle = '#282828'
  ctx.beginPath()
  ctx.moveTo(300 + x, 304 + y) // 左＿上
  ctx.quadraticCurveTo(297 + x, 307 + y, 303 + x, 311 + y) // 左＿下
  ctx.quadraticCurveTo(338 + x, 305 + y, 345 + x, 305 + y) // 右＿下
  ctx.quadraticCurveTo(347 + x, 302 + y, 345 + x, 298 + y) // 右＿上
  ctx.quadraticCurveTo(322 + x, 296 + y, 300 + x, 304 + y) // 左＿上
  ctx.fill()
  ctx.moveTo(303 + x, 309 + y) // 左＿上
  ctx.quadraticCurveTo(315 + x, 304 + y, 347 + x, 303 + y) // 左＿下
  ctx.stroke()
  ctx.closePath()
  // 左下＿右上
  ctx.beginPath()
  ctx.moveTo(316 + x, 320 + y) // 左＿上
  ctx.quadraticCurveTo(315 + x, 326 + y, 320 + x, 330 + y) // 左＿下
  ctx.quadraticCurveTo(325 + x, 311 + y, 344 + x, 286 + y) // 右＿下
  ctx.quadraticCurveTo(344 + x, 283 + y, 342 + x, 280 + y) // 右＿上
  ctx.quadraticCurveTo(319 + x, 303 + y, 316 + x, 320 + y) // 左＿上
  ctx.fill()
  ctx.moveTo(319 + x, 327 + y) // 左＿上
  ctx.quadraticCurveTo(324 + x, 306 + y, 344 + x, 284 + y) // 左＿下
  ctx.stroke()
  ctx.closePath()
}
